import React, { useEffect, useState } from "react"

import { Button, Typography } from "antd"
import { setIsInviteMembersModalOpen, setIsPlansModalOpen } from "features/common/model/slice/appSlice"
import { MemberRole } from "features/team/model/types/members"
import { getUserRole } from "features/user/model/selectors/userSelectors"
import { fetchUserDataThunk } from "features/user/model/slice/userSlice"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { hasAccess } from "shared/utils/access"
import { styled } from "styled-components"
import { familyMembersSelector, familySelector } from "features/team/model/selectors/teamSelectors"
import { ConfirmationModal } from "features/common/ui/ConfirmationModal"
import { useTranslation } from "react-i18next"

const { Title } = Typography

const SContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  margin-left: 2px;
`

export const ProfilePageHeader: React.FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  
  const userRole = useAppSelector(getUserRole)
  const familyMembers = useAppSelector(familyMembersSelector)
  const familyData = useAppSelector(familySelector)

  const [maxMembersConfirmationModalOpen, setMaxMembersConfirmationModalOpen] = useState(false)

  const handleOpenPlansModal = () => {
    setMaxMembersConfirmationModalOpen(false)
    dispatch(setIsPlansModalOpen(true))
  }

  const handleInviteMembers = () => {
    if (familyMembers.length >= familyData?.members_limit) {
      setMaxMembersConfirmationModalOpen(true)

      return
    }

    dispatch(setIsInviteMembersModalOpen(true))
  }

  useEffect(() => {
    dispatch(fetchUserDataThunk())
  }, [])

  return (
    <SContainer>
      <Title level={2}
        style={{ fontSize: 32, marginTop: 20, letterSpacing: 'unset' }}
      >
        Settings
      </Title>

      {hasAccess(userRole, [MemberRole.ADMIN, MemberRole.OWNER]) && (
        <Button type="primary"
          onClick={handleInviteMembers}
        >
          Invite members
        </Button>
      )}

      <ConfirmationModal
        open={!!maxMembersConfirmationModalOpen}
        title={t('l_plans_maxMembersTitle')}
        description={t('l_plans_maxMembersMsg')}
        onCancel={() => setMaxMembersConfirmationModalOpen(false)}
        onConfirm={handleOpenPlansModal}
        confirmText={t('a_plans_upgradeYourPlan')}
        cancelText={t('a_common_cancel')}
      />
    </SContainer>
  )
}